export default __webpack_public_path__ + "static/media/santuario.0e7dbe7f.jpg";